var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gender"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.76471 16.8824H7.70588C7.40588 16.8824 7.15441 16.7809 6.95147 16.5779C6.74853 16.375 6.64706 16.1235 6.64706 15.8235C6.64706 15.5235 6.74853 15.2721 6.95147 15.0691C7.15441 14.8662 7.40588 14.7647 7.70588 14.7647H8.76471V12.5412C7.37059 12.2941 6.22794 11.6279 5.33676 10.5426C4.44559 9.45735 4 8.2 4 6.77059C4 5.16471 4.56912 3.80147 5.70735 2.68088C6.84559 1.56029 8.21765 1 9.82353 1C11.4294 1 12.8015 1.56029 13.9397 2.68088C15.0779 3.80147 15.6471 5.16471 15.6471 6.77059C15.6471 8.2 15.2015 9.45735 14.3103 10.5426C13.4191 11.6279 12.2765 12.2941 10.8824 12.5412V14.7647H11.9412C12.2412 14.7647 12.4926 14.8662 12.6956 15.0691C12.8985 15.2721 13 15.5235 13 15.8235C13 16.1235 12.8985 16.375 12.6956 16.5779C12.4926 16.7809 12.2412 16.8824 11.9412 16.8824H10.8824V17.9412C10.8824 18.2412 10.7809 18.4926 10.5779 18.6956C10.375 18.8985 10.1235 19 9.82353 19C9.52353 19 9.27206 18.8985 9.06912 18.6956C8.86618 18.4926 8.76471 18.2412 8.76471 17.9412V16.8824ZM9.82353 10.5294C10.8471 10.5294 11.7206 10.1676 12.4441 9.44412C13.1676 8.72059 13.5294 7.84706 13.5294 6.82353C13.5294 5.8 13.1676 4.92647 12.4441 4.20294C11.7206 3.47941 10.8471 3.11765 9.82353 3.11765C8.8 3.11765 7.92647 3.47941 7.20294 4.20294C6.47941 4.92647 6.11765 5.8 6.11765 6.82353C6.11765 7.84706 6.47941 8.72059 7.20294 9.44412C7.92647 10.1676 8.8 10.5294 9.82353 10.5294Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/female-icon.1f04032f8a5f8d3a4cc4b1855e38040e.svg";
export { ForwardRef as ReactComponent };